import CurrentUser from './currentUser'
import axios from 'axios'
import router from '@/router'

// Acces via  this.$store.state.auth.currentUser
const state = {
  currentUser: null
}

const getters = {
  // Acces via  this.$store.getters.currentUser
  currentUser(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser
    }
  },
  estAuthentifie(state) {
    if (state.currentUser == null) {
      return false
    } else {
      return state.currentUser != null
    }
  },
  codeUsager(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.codeUsager
    }
  },
  agentConnecte(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.agentData
    }
  },
  agentConnecteInfosJDE(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.infosClientJDE
    }
  },
  languePreferee(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.languePreferee
    }
  },
  accessToken(state) {
    if (state.currentUser == null) {
      return null
    } else {
      return state.currentUser.accessToken
    }
  }
}

const actions = {
  login({ commit }, usagerData) {
    commit('mLogin', usagerData)
  },
  logout({ commit }) {
    commit('mLogout')
    if (router.currentRoute.name != 'login') {
      console.log('logout et pas page /login, redirection vers /login')
      router.push({ name: 'login' })
    }
  },
  tokenExpire({ commit }) {
    commit('mLogout')
    router.push({ name: 'tokenExpire' })
  }
}

const mutations = {
  mLogin(state, usagerData) {
    state.currentUser = CurrentUser.from(usagerData)
  },
  mLogout(state) {
    state.currentUser = null
    axios.defaults.headers.Authorization = null
  }
}

export default {
  state,
  mutations,
  getters,
  actions
}
